<template>
  <div class="hkl-guideline">
    <Collapse
      v-for="(section, i) in guidelines"
      ref="collapseRefs"
      :key="section.id"
      class="small-12"
      v-bind="proxyAttrs"
    >
      <template slot="title">
        <div class="hkl-guideline__title">
          <slot
            name="secTitle"
            :section="section"
            :index="i"
          >
            <span>{{ parseOrderNumber(section.displayOrder) }}</span>
            <span>{{ section.value }}</span>
          </slot>
        </div>
      </template>
      <template slot="additional">
        <slot
          name="secTitleAction"
          :section="section"
          :index="i"
        />
      </template>
      <template slot="content">
        <div
          v-for="(item, j) in section.sectionContent"
          :key="item.id"
          class="hkl-guideline__child-box"
        >
          <div class="hkl-guideline__child-contentbox row">
            <div class="hkl-guideline__child-content small-12">
              <slot
                name="item"
                :section="section"
                :sectionItem="item"
                :parentIndex="i"
                :index="j"
              >
                <div class="hkl-guideline__child-number">
                  {{ parseOrderNumber(j + 1) }}
                </div>
                <pre class="hkl-guideline__child-value">{{ item.value }}</pre>
              </slot>
            </div>
            <template v-for="(rec, k) in item.actionTexts">
              <div
                v-if="rec"
                :key="`${item.id}_${k}`"
                class="tip small-12"
              >
                <span class="tip__text">{{ rec }}</span>
              </div>
            </template>
          </div>
          <slot
            name="itemAction"
            :section="section"
            :sectionItem="item"
            :parentIndex="i"
            :index="j"
          />
        </div>
      </template>
    </Collapse>
  </div>
</template>

<script>
import { ref, computed } from 'vue-demi'
import Collapse from '@/controls/Collapse'
import { parseOrderNumber } from './util'

export default {
  components: {
    Collapse,
  },
  props: {
    guidelines: {
      type: [Array, Object],
      default: () => [],
    },
  },
  setup (_, { attrs }) {
    const collapseRefs = ref([])
    const proxyAttrs = computed(() => {
      const defaultAttrs = {
        enableExpandByClickingTitle: true,
        expand: false,
      }
      return Object.assign({}, defaultAttrs, attrs)
    })

    return {
      collapseRefs,
      parseOrderNumber,
      proxyAttrs,
    }
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';
@import './guideline.scss';
.tip {
  margin-top: 10px;
}
// Clone from `src/modules/tenantProjects/postFitOutLetter/PostFitOutGuidelineSelector`
.hkl-guideline.card-mode ::v-deep {
  .hkl-guideline__child-box {
    margin-bottom: 0;
  }
  .hkl-guideline__child-contentbox {
    border: 0;
  }
  .title-container {
    margin-bottom: 0;
  }
  .collapse .content.with-border {
    border-width: 1px;
    border-style: solid;
    border-top: 0;
    padding: 10px 0;
    margin-bottom: 0;
  }
}
</style>
